

<template>
    <div class="OrderSearch mx-auto"> 
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <!-- 頭貼照片 -->        
        <div class="d-flex flex-column mb-2">
            <img class="userPhoto mx-auto" :src="pictureUrl" v-if="profile.pictureUrl"/>
            <div class="userName mx-auto">{{displayName}}</div>
        </div>
        <!-- 報價單 -->
        <div class="goButton d-flex justify-content-center align-items-center" @click="GoEstimateListPage">
            <font-awesome-icon class="icon mx-2" :icon="['fas','magnifying-glass']" />
            報價單
        </div>
        <!-- 報名表 -->
        <div class="goButton d-flex justify-content-center align-items-center" @click="GoRegistrationListPage">
            <font-awesome-icon class="icon mx-2" :icon="['fas','magnifying-glass']" />
            報名表
        </div>



    
    </div>
</template>


<script>
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'
import Nav from '@/components/Nav'
import liff from '@line/liff';

export default {
    name: 'OrderSearch',
    components:{
        Nav,
    },
    data () {
        return {
            UserData:{},
            ProviderUserId:'',
            AccessToken:'',
            profile:null,
            DecodedIDToken:null,
            displayName:'',
            pictureUrl:'',
            showLoading:'',
        }
    },
    
    beforeCreate(){
        liff.init({ liffId: process.env.LIFFORDER })
        .then(async () => {
            if (liff.isLoggedIn()) {
                this.profile = liff.getProfile();
                this.AccessToken = liff.getAccessToken();
                this.DecodedIDToken = liff.getDecodedIDToken();
                console.log('profile',this.profile)
                console.log('AccessToken',this.AccessToken)
                console.log('DecodedIDToken',this.DecodedIDToken)
                sessionStorage.setItem('DecodedIDToken', JSON.stringify(this.DecodedIDToken));
                sessionStorage.setItem('AccessToken',this.AccessToken);
                this.profile.then((value) => {
                    sessionStorage.setItem('profile', JSON.stringify(value));
                    this.ProviderUserId = value.userId;
                    this.displayName = value.displayName
                    this.pictureUrl = value.pictureUrl
                    this.$nextTick(() => {
                        console.log('ProviderUserId',this.ProviderUserId);
                        this.CheckThirdPartyAuthUserId();
                    });
                });
                
                
            } else {
                liff.login();
            }
        })
        .catch((err) => {
            console.log(err);
        })
    },
    methods:{
        //驗證是否綁定過Line ID
        CheckThirdPartyAuthUserId(){
            this.showLoading = true;
            const api =`${process.env.APIPATH}/api/Login/CheckThirdPartyAuthUserId`;
            const inputdata = 
            {
                "ProviderUserId":this.ProviderUserId,
                "ProviderId":1, // Line用,
                "AccessToken":this.AccessToken
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){
                        this.UserData = response.data.userData;
                        sessionStorage.setItem('UserData',JSON.stringify(this.UserData));
                    }else{
                        //跳轉登入畫面
                        this.$router.push({
                            name: 'Login',
                        });
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        GoEstimateListPage(){
            this.$router.push({
                name: 'EstimateList',
            });
        },
        GoRegistrationListPage(){
            this.$router.push({
                name: 'RegistrationList',
            });
        },
    },
    created(){
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/OrderSearch.vue